/**
 * Answer markdown
 * ---------------------------------------------------------------------------
 * Model answers come back as GitHub-flavoured markdown, so a comparison is a
 * real table rather than a wall of pipes. Rendering the string raw printed
 * those pipes as ASCII; this maps each node onto the design system instead.
 */

import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const AnswerMarkdown: React.FC<{ children: string }> = ({ children }) => (
  <div className="md">
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        /* tables get the same chrome as every other table in the app */
        table: ({ children: c }) => (
          <div className="md-table tscroll">
            <table>{c}</table>
          </div>
        ),
        /* a cell holding only a number is right-aligned and tabular */
        td: ({ children: c, ...props }) => {
          const text = React.Children.toArray(c).join('');
          const numeric = /^[\s$€£]*-?[\d,.]+\s*[%x]?\s*$/.test(text) && /\d/.test(text);
          return (
            <td className={numeric ? 'num' : undefined} {...props}>
              {c}
            </td>
          );
        },
        th: ({ children: c, ...props }) => {
          const text = React.Children.toArray(c).join('');
          const numeric = /(amount|total|value|revenue|count|qty|quantity|price|%|margin)/i.test(
            text
          );
          return (
            <th className={numeric ? 'num' : undefined} {...props}>
              {c}
            </th>
          );
        },
        code: ({ className, children: c, ...props }) => {
          const inline = !String(className || '').includes('language-');
          return inline ? (
            <code className="md-code" {...props}>
              {c}
            </code>
          ) : (
            <pre className="md-pre">
              <code {...props}>{c}</code>
            </pre>
          );
        },
        a: ({ children: c, href }) => (
          <a href={href} target="_blank" rel="noreferrer noopener">
            {c}
          </a>
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  </div>
);
